/* 🤖 this file was generated by svg-to-ts*/
export const iconAccuracyCircle = {
  name: 'accuracy',
  data: `<svg width="29" height="28" viewBox="0 0 29 28" fill="none" xmlns="http://www.w3.org/2000/svg">
  <circle cx="14.2881" cy="14" r="14" fill="url(#paint0_linear_250_1387)" fill-opacity="0.15"/>
  <path d="M10.8195 17.6166L7.63807 14.378C7.46678 14.2032 7.23422 14.105 6.9917 14.105C6.74918 14.105 6.51662 14.2032 6.34532 14.378C5.98776 14.742 5.98776 15.33 6.34532 15.694L10.1777 19.5953C10.5353 19.9593 11.1129 19.9593 11.4705 19.5953L21.1706 9.72064C21.5282 9.35664 21.5282 8.76864 21.1706 8.40464C20.9993 8.22987 20.7668 8.13165 20.5243 8.13165C20.2817 8.13165 20.0492 8.22987 19.8779 8.40464L10.8195 17.6166Z" fill="url(#paint1_linear_250_1387)" stroke="url(#paint2_linear_250_1387)"/>
  <defs>
  <linearGradient id="paint0_linear_250_1387" x1="23.9481" y1="15.1666" x2="4.34809" y2="15.1666" gradientUnits="userSpaceOnUse">
  <stop stop-color="#2FEA9B"/>
  <stop offset="1" stop-color="#7FDD53"/>
  </linearGradient>
  <linearGradient id="paint1_linear_250_1387" x1="19.0578" y1="14.489" x2="8.30459" y2="14.489" gradientUnits="userSpaceOnUse">
  <stop stop-color="#2FEA9B"/>
  <stop offset="1" stop-color="#7FDD53"/>
  </linearGradient>
  <linearGradient id="paint2_linear_250_1387" x1="19.0578" y1="14.489" x2="8.30459" y2="14.489" gradientUnits="userSpaceOnUse">
  <stop stop-color="#2FEA9B"/>
  <stop offset="1" stop-color="#7FDD53"/>
  </linearGradient>
  </defs>
  </svg>`,
}
